import React, { Component } from 'react'

export default class LinearProgressBar extends Component {
    state = {

    }
    render() {
        return (
            <div className='flexcb p-3' style={{ backgroundColor: '#F3EFF6' }}>
                {this.props.progress.map((prop, index) => {
                    return (
                        <div className='flexcc w-100' >
                            <button className='flexcc flex-column' style={{width:'50px'}}>
                                <div className='flexcc br-50' style={{ backgroundColor: prop.color2, width:30, height:30 }}>
                                    <img className='flexcc' width={26} src={prop.fistIcon} />
                                </div>
                                <p className='text-center main-c4'>{prop.firtstep}</p>
                            </button>
                            <div className="rreverse br-20 mx-2 w-100" style={{ backgroundColor: prop.color1, height: '8px', marginTop:'-12px' }}>
                                <div className='transition-all br-20' style={{ backgroundColor: prop.color2, height: '8px', width:'30%' }}></div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}
